import React from "react"
import type { ArquivosAplicativoActionModel } from "./arquivosAplicativoActions"
import type { ArquivosAplicativoModel } from "../models/arquivosAplicativoModel"
import { ArquivosAplicativoInicial } from "../models/arquivosAplicativoModel"

export type ArquivosAplicativoContextType = {
    arquivos: ArquivosAplicativoModel
    dispatch: React.Dispatch<ArquivosAplicativoActionModel>
    erroCarregamento: string | null
    uploadArquivo: (campo: string, file: File) => Promise<void>
    removerArquivo: (campo: string) => Promise<void>
}

export const ArquivosAplicativoContext = React.createContext<ArquivosAplicativoContextType>({
    arquivos: ArquivosAplicativoInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    uploadArquivo: async () => undefined,
    removerArquivo: async () => undefined,
})
